export default "__VITE_ASSET__CntzZ5qU__"